import React from 'react'
import TableCellMobile from './TableCellMobile'
import TableCellDesktop from './TableCellDesktop'

const TableCellMontant = ({
  item,
  label,
  device
}) => {
  const value = item.montant
  const object = {
    value: value + '€',
    empty: (value === 0)
  }
  return (device.mobile)
    ? <TableCellMobile
        label={label}
        {...object}
      />
    : <TableCellDesktop
        max={75}
        {...object}
      />
}

export default TableCellMontant
